import type { RouteLocationRaw, Router } from 'vue-router'

// The previous history entry as vue-router recorded it (`null` on a fresh entry, e.g. a deep link).
export function previousPath(router: Router): string | null {
  const back: unknown = router.options.history.state.back
  return typeof back === 'string' ? back.split(/[?#]/)[0] : null
}

// Back means rewinding: when the entry before this one is the page we would go to anyway, step back in the history.
// Otherwise the target replaces the current entry, so going back never adds an entry and no loop can form.
export function goBack(router: Router, target: RouteLocationRaw): void {
  const path = router.resolve(target).path
  if (previousPath(router) === path) router.back()
  else void router.replace(target)
}

// For the `‹` arrows, which are links: a plain click rewinds, a modified click (new tab) keeps the link's job.
export function onBackClick(event: Pick<MouseEvent, 'button' | 'ctrlKey' | 'metaKey' | 'shiftKey' | 'altKey' | 'preventDefault'>, router: Router, target: RouteLocationRaw): void {
  if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return
  event.preventDefault()
  goBack(router, target)
}
